/* eslint-disable react/require-default-props */
import React from 'react';
import moment from 'moment';
import { orderBy } from 'lodash';
import PropTypes from 'prop-types';
import withStatsig from '../../../hocs/withStatsig';
import {
    countWords,
    truncateString,
    getRatingDetails,
    setRatingChoice,
} from '../../../../utils';
import {
    hasSchoolLinked,
    isClubAdminOrOwner,
    canRunEvents,
    isClubOwner,
    getClubNameDisplay,
    getEventsListByEventType,
    EventTypes,
    isPersonalClub,
    isTournamentClub,
    isTeamTennisClub,
    isProCollegeClubAdminOrOwner,
    isFreeCollegeClubOwnerOrAdmin,
    isCollegeClub,
} from '../../../../utils/clubs';
import TMSEventsList from '../TMSEventsList';
import EventsCardList from '../../../Events/EventsDisplay/eventsCardList';
import PlayersCardList from '../../../Players/PlayersDisplay/playersCardList';
import SidePanelTopSection from '../SidePanelTopSection';
import SidePanel from '../SidePanel';
import SidePanelBottomSection from '../SidePanelBottomSection';
import Linkify from '../../../text/Linkify';
import Power6Stats from './Power6Stats';
import HighSchoolStandings from './HighSchoolStandings';
import AdultTeamTennisStandings from './AdultTeamTennisStandings';

import styles from '../../../../pages/ClubProfiles/club.scss';
import { EventHsTypes, EventScheduleTypes } from '../../../../utils/eventConstants';
import { ClubProfileTabIdentifiers, CLUB_PROFILE_VIEW_TYPES } from '../../../../utils/constants';

const _ = { orderBy };

class OverviewTabContent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            descriptionExpanded: false,
        };
    }

    render() {
        const {
            clubDetails,
            auth,
            clubType,
            handleUploadPhoto,
            handleUploadLogoStart,
            removeSponsorLogo,
            tmsEventsFetchState,
            schoolDetailsState,
            schoolDetails,
            handleTabClick,
            onUpgradeToCollegeClick,
            onShowAllEventsClick,
            onCreateEventClick,
            isAdminOrOwner,
            sendMessage,
            power6Stats,
            power6StatsState,
            isClubMember,
            highSchoolStandingsSeasons,
            highSchoolStandings,
            highSchoolStandingsState,
            adultTeamTennisRosterState,
            adultTeamTennisRoster,
            adultTeamTennisEvents,
            adultTeamTennisStandings,
            adultTeamTennisStandingsState,
            getAdultTeamTennisStandings,
            coreUI,
            checkGate,
            featureGates,
        } = this.props;

        const {
            description,
            schoolProfile,
            tierType,
            name,
        } = clubDetails;

        const collegeDualMatchFlagEnabled = checkGate(featureGates.COLLEGE_DUAL_MATCH);

        const { RECENT, UPCOMING, INPROGRESS } = EventScheduleTypes;

        const userLoggedIn = auth?.user;
        const userIsPowered = auth?.user?.isPowered;

        // Initialize the Set for event IDs
        const InprogressEventIds = new Set();
        const UpcomingEventIds = new Set();
        const currentDate = moment();
        const displayName = getClubNameDisplay(tierType, schoolProfile, name);
        const clubIsFreeCollege = clubDetails?.isFreeCollege;

        let upcomingTeamEvents = clubDetails && getEventsListByEventType(clubDetails, UPCOMING, EventTypes.TEAM_MATCHES, null, clubDetails.tierType.isHighSchool ? EventHsTypes.OFFICIAL : null);
        let recentTeamEvents = clubDetails?.tierType?.isHighSchool === false ? clubDetails && getEventsListByEventType(clubDetails, RECENT, EventTypes.TEAM_MATCHES) : [];

        const upcomingTmsEvents = clubDetails && getEventsListByEventType(clubDetails, UPCOMING, EventTypes.TMS, null, clubDetails.tierType.isHighSchool ? EventHsTypes.OFFICIAL : null);
        const filteredUpcomingEvents = upcomingTmsEvents?.filter(event => {
            if (event.momentStartDate?.isAfter(currentDate)) {
                if (!UpcomingEventIds.has(event.id)) {
                    // If the event ID is not in the Set, add it and include this event
                    UpcomingEventIds.add(event.id);
                    return true;
                }
            }
            return false;
        });
        const inProgessEvents = upcomingTmsEvents?.filter(event => {
            if (event.momentStartDate?.isSameOrBefore(currentDate) && event.momentEndDate?.isAfter(currentDate)) {
                // Define a Set to keep track of unique event IDs
                if (!InprogressEventIds.has(event.id)) {
                    // If the event ID is not in the Set, add it and include this event
                    InprogressEventIds.add(event.id);
                    return true;
                }
            }
            return false;
        });

        let recentTmsEvents = clubDetails?.tierType?.isHighSchool === false ? clubDetails && getEventsListByEventType(clubDetails, RECENT, EventTypes.TMS) : [];

        // if in case college dual match flag is turn off then we will not show the dual matches on schedule tab
        if (isCollegeClub(clubDetails?.tierType?.name) && !collegeDualMatchFlagEnabled) {
            upcomingTeamEvents = upcomingTeamEvents?.filter(ev => ev.source !== 'tms-dual-match');
            recentTeamEvents = recentTeamEvents?.filter(ev => ev.source !== 'tms-dual-match');
        }

        if (clubDetails?.tierType?.isHighSchool) {
            recentTeamEvents = getEventsListByEventType(clubDetails, RECENT, EventTypes.TEAM_MATCHES, null, EventHsTypes.OFFICIAL);
            recentTmsEvents = getEventsListByEventType(clubDetails, RECENT, EventTypes.TMS, null, EventHsTypes.OFFICIAL);
        }
        const isAdultTeamTennisClub = isTeamTennisClub(tierType);
        const upcomingAttEvents = adultTeamTennisEvents?.upcomingEvents;
        const pastAttEvents = adultTeamTennisEvents?.pastEvents;
        const hasPermission = isProCollegeClubAdminOrOwner(clubDetails) || isFreeCollegeClubOwnerOrAdmin(clubDetails);
        const canPerformActions = collegeDualMatchFlagEnabled && hasPermission;
        return (
            <div className="row">
                <div className="col-md-8">
                    {description && description.length > 0 && (
                        <div>
                            <h6 className="d-block">{`About ${displayName}`}</h6>
                            <Linkify>
                                {countWords(description) < 40
                                    ? (<p className="text-line-break">{description}</p>)
                                    : (
                                        <p className="text-line-break">
                                            {this.state.descriptionExpanded
                                                ? clubDetails.description
                                                : truncateString(clubDetails.description, 40)}
                                            <span
                                                className={`${styles.readMore}`}
                                                onClick={() => {
                                                    this.setState(prevState => ({
                                                        descriptionExpanded: !prevState.descriptionExpanded,
                                                    }));
                                                }}
                                            >
                                                {this.state.descriptionExpanded ? 'Read less' : 'Read more'}
                                            </span>
                                        </p>
                                    )}
                            </Linkify>
                        </div>
                    )}
                    <div className="d-block d-md-none">
                        <SidePanelTopSection
                            auth={auth}
                            clubType={clubType}
                            clubDetails={clubDetails}
                            handleUploadPhoto={handleUploadPhoto}
                            handleUploadLogoStart={handleUploadLogoStart}
                            removeSponsorLogo={removeSponsorLogo}
                            sendMessage={sendMessage}
                        />
                    </div>
                    {clubDetails?.tierType?.isCollege && clubDetails?.schoolProfile && (
                        <div className={styles.titleMargins}>
                            <Power6Stats
                                clubDetails={clubDetails}
                                power6Stats={power6Stats}
                                power6StatsState={power6StatsState}
                                getPower6Stats={this.props.getPower6Stats}
                                data-testid="club-profile.overview.power6-stats"
                            />
                        </div>
                    )}

                    {(clubDetails?.tierType?.isHighSchool && clubDetails?.schoolProfile) && (
                        <div className={styles.titleMargins}>
                            <HighSchoolStandings
                                clubDetails={clubDetails}
                                highSchoolStandingsSeasons={highSchoolStandingsSeasons}
                                highSchoolStandings={highSchoolStandings}
                                highSchoolStandingsState={highSchoolStandingsState}
                                getHighSchoolStandingsSeasons={this.props.getHighSchoolStandingsSeasons}
                                getHighSchoolStandings={this.props.getHighSchoolStandings}
                            />
                        </div>
                    )}

                    {isAdultTeamTennisClub && (
                        <AdultTeamTennisStandings
                            clubDetails={clubDetails}
                            adultTeamTennisStandings={adultTeamTennisStandings}
                            adultTeamTennisStandingsState={adultTeamTennisStandingsState}
                            getAdultTeamTennisStandings={getAdultTeamTennisStandings}
                        />
                    )}

                    {isAdultTeamTennisClub && adultTeamTennisRosterState.completed && adultTeamTennisRosterState.successful &&
                        adultTeamTennisRoster.length > 0 && (
                            <>
                                <h6>Top Players</h6>
                                <PlayersCardList
                                    players={adultTeamTennisRoster &&
                                        adultTeamTennisRoster.length > 0 &&
                                        _.orderBy(adultTeamTennisRoster, (player) => {
                                            const singlesRating = getRatingDetails(setRatingChoice({ player, ratingType: 'singles' }), userIsPowered);
                                            return singlesRating.actualValue;
                                        }, ['desc']).slice(0, 3)}
                                    showAllLinkVisible={userLoggedIn}
                                    onShowAllClick={(ev) => {
                                        handleTabClick(ev, ClubProfileTabIdentifiers.ROSTER);
                                    }}
                                    showAllLinkText={`See Full Roster`}
                                    isAdminOrOwner={isAdminOrOwner}
                                    sendMessage={sendMessage}
                                    showTennisRatings
                                    showPickleBallRatings
                                    checkGate={checkGate}
                                    featureGates={featureGates}
                                />
                            </>
                        )}

                    {hasSchoolLinked(clubDetails) && schoolDetailsState && schoolDetailsState.complete && schoolDetailsState.successful &&
                        (schoolDetails.roster.length > 0 ? (
                            <>
                                <h6>Top Players</h6>
                                {(() => {
                                    const topPlayers = schoolDetails.roster &&
                                        schoolDetails.roster.length > 0 &&
                                        _.orderBy(schoolDetails.roster, [
                                            // Primary sort: reliability/UTR range priority (same as Roster)
                                            (player) => {
                                                const ratingProgress = player.ratingProgressSingles ?? player.ratingProgress ?? 0;
                                                if (ratingProgress === 100) {
                                                    // fully reliable players first
                                                    return 2;
                                                }
                                                if (player.utrRange) {
                                                    // people with UTR range next
                                                    return 1;
                                                }
                                                // unrated players last
                                                return 0;
                                            },
                                            // Secondary sort: actual rating value (same as Roster)
                                            (player) => {
                                                try {
                                                    const singlesRating = getRatingDetails(setRatingChoice({ player, ratingType: 'singles' }), userIsPowered);
                                                    return parseFloat(singlesRating?.actualValue) || 0;
                                                } catch (error) {
                                                    // eslint-disable-next-line no-console
                                                    console.warn('[OverviewTabContent] Error getting rating for player sorting:', error, player);
                                                    return 0;
                                                }
                                            },
                                        ], ['desc', 'desc']).slice(0, 3);

                                    return (
                                        <PlayersCardList
                                            players={topPlayers}
                                            clubProfileViewType={tierType.isCollege ? CLUB_PROFILE_VIEW_TYPES.COLLEGE : CLUB_PROFILE_VIEW_TYPES.HIGHSCHOOL}
                                            showAllLinkVisible={userLoggedIn}
                                            onShowAllClick={(ev) => {
                                                handleTabClick(ev, ClubProfileTabIdentifiers.ROSTER);
                                            }}
                                            showAllLinkText={`See Full Roster`}
                                            isAdminOrOwner={isAdminOrOwner}
                                            showTennisRatings
                                            showPickleBallRatings={false}
                                            checkGate={checkGate}
                                            featureGates={featureGates}
                                        />
                                    );
                                })()}
                            </>
                        ) : (
                            <>
                                {(!isAdminOrOwner || tierType.isHighSchool) ? null : (
                                    <>
                                        <h6>Top Players</h6>
                                        <div className={`${styles.placeHolderGrid}`}>
                                            <div className={`${styles.overlay}`} />
                                            <div className={`${styles.actionWrapper}`}>
                                                <button
                                                    type="button"
                                                    className={`btn btn-primary btn-sm text-uppercase`}
                                                    onClick={() => {
                                                        this.props.updateRosterTabState(this.props.rosterTabState);
                                                    }}
                                                >
                                                    Add Roster player
                                                </button>
                                            </div>
                                        </div>
                                    </>
                                )}
                            </>
                        ))}
                    {hasSchoolLinked(clubDetails) && ((upcomingTeamEvents && upcomingTeamEvents.length > 0) ||
                        (isClubAdminOrOwner(clubDetails) && !clubIsFreeCollege)) && (
                            <>
                                <h6>Upcoming Team Events</h6>
                                <EventsCardList
                                    listTypeName={`Upcoming`}
                                    events={upcomingTeamEvents && upcomingTeamEvents.length > 0 && upcomingTeamEvents.slice(0, 2)}
                                    auth={auth}
                                    clubName={displayName}
                                    clubId={clubDetails.id}
                                    showAllLinkVisible={userLoggedIn}
                                    isAdminOrOwner={isClubAdminOrOwner(clubDetails)}
                                    isClubMember={isClubMember}
                                    onCreateEventClick={onCreateEventClick}
                                    onShowAllClick={(ev) => {
                                        handleTabClick(ev, ClubProfileTabIdentifiers.SCHEDULE);
                                    }}
                                    eventsTypeName={`Team Events`}
                                    showAdminOptions={isAdminOrOwner || canPerformActions}
                                    isCollege={clubDetails.tierType.isCollege}
                                    isProfilePage={true}
                                />
                            </>
                        )}
                    {hasSchoolLinked(clubDetails) && (recentTeamEvents && recentTeamEvents.length > 0) && (
                        <>
                            <h6>Past Team Events</h6>
                            <EventsCardList
                                listTypeName={`Past`}
                                events={recentTeamEvents && recentTeamEvents.length > 0 && recentTeamEvents.slice(0, 2)}
                                auth={auth}
                                clubName={displayName}
                                clubId={clubDetails.id}
                                showAllLinkVisible={userLoggedIn}
                                isClubMember={isClubMember}
                                onShowAllClick={(ev) => {
                                    handleTabClick(ev, ClubProfileTabIdentifiers.SCHEDULE);
                                }}
                                eventsTypeName={`Team Events`}
                                showAdminOptions={isAdminOrOwner || canPerformActions}
                                isCollege={clubDetails.tierType.isCollege}
                                isProfilePage={true}
                            />
                        </>
                    )}

                    {isAdultTeamTennisClub && ((upcomingAttEvents && upcomingAttEvents.length > 0) ||
                        (isClubAdminOrOwner(clubDetails) && !clubIsFreeCollege)) && (
                            <>
                                <h6>Upcoming Team Events</h6>
                                <EventsCardList
                                    listTypeName={`Upcoming`}
                                    events={upcomingAttEvents && upcomingAttEvents.length > 0 && upcomingAttEvents.slice(0, 2)}
                                    auth={auth}
                                    clubName={displayName}
                                    clubId={clubDetails.id}
                                    showAllLinkVisible={userLoggedIn}
                                    isAdminOrOwner={isClubAdminOrOwner(clubDetails)}
                                    isClubMember={isClubMember}
                                    onCreateEventClick={onCreateEventClick}
                                    isAdultTeamTennisClub={isAdultTeamTennisClub}
                                    onShowAllClick={(ev) => {
                                        handleTabClick(ev, ClubProfileTabIdentifiers.SCHEDULE);
                                    }}
                                    eventsTypeName={`Team Events`}
                                    isProfilePage={true}
                                />
                            </>
                        )}
                    {isAdultTeamTennisClub && (pastAttEvents && pastAttEvents.length > 0) && (
                        <>
                            <h6>Past Team Events</h6>
                            <EventsCardList
                                listTypeName={`Past`}
                                events={pastAttEvents && pastAttEvents.length > 0 && pastAttEvents.slice(0, 2)}
                                auth={auth}
                                clubName={displayName}
                                clubId={clubDetails.id}
                                showAllLinkVisible={userLoggedIn}
                                isClubMember={isClubMember}
                                isAdultTeamTennisClub={isAdultTeamTennisClub}
                                onShowAllClick={(ev) => {
                                    handleTabClick(ev, ClubProfileTabIdentifiers.SCHEDULE);
                                }}
                                eventsTypeName={`Team Events`}
                                isProfilePage={true}
                            />
                        </>
                    )}

                    {!hasSchoolLinked(clubDetails) && !isAdultTeamTennisClub && (
                        <>
                            <h6>Upcoming Events</h6>
                            <TMSEventsList
                                eventsList={filteredUpcomingEvents}
                                type={UPCOMING}
                                showAll={false}
                                auth={auth}
                                coreUI={coreUI}
                                isAdminOrOwner={isClubAdminOrOwner(clubDetails)}
                                canRunEvents={canRunEvents(clubDetails)}
                                isOwner={isClubOwner(clubDetails)}
                                isPersonalClub={isPersonalClub(clubDetails.tierType)}
                                isTournamentClub={isTournamentClub(clubDetails.tierType)}
                                isClubMember={isClubMember}
                                tmsEventsFetchState={tmsEventsFetchState}
                                clubIsFreeCollege={clubIsFreeCollege}
                                onUpgradeToCollegeClick={onUpgradeToCollegeClick}
                                onShowAllClick={(ev) => {
                                    onShowAllEventsClick(ev, UPCOMING);
                                }}
                                onCreateEventClick={onCreateEventClick}
                                isProfilePage={false}
                            />
                        </>
                    )}
                    {!hasSchoolLinked(clubDetails) && !isAdultTeamTennisClub && (inProgessEvents && inProgessEvents.length > 0) && (
                        <>
                            <h6>In Progress Events</h6>
                            <TMSEventsList
                                eventsList={inProgessEvents}
                                type={INPROGRESS}
                                showAll={false}
                                auth={auth}
                                coreUI={coreUI}
                                isAdminOrOwner={isClubAdminOrOwner(clubDetails)}
                                canRunEvents={canRunEvents(clubDetails)}
                                isOwner={isClubOwner(clubDetails)}
                                isPersonalClub={isPersonalClub(clubDetails.tierType)}
                                isTournamentClub={isTournamentClub(clubDetails.tierType)}
                                isClubMember={isClubMember}
                                tmsEventsFetchState={tmsEventsFetchState}
                                clubIsFreeCollege={clubIsFreeCollege}
                                onUpgradeToCollegeClick={onUpgradeToCollegeClick}
                                onShowAllClick={ev => {
                                    onShowAllEventsClick(ev, INPROGRESS);
                                }}
                                onCreateEventClick={onCreateEventClick}
                                isProfilePage={false}
                            />
                        </>
                    )}
                    {!hasSchoolLinked(clubDetails) && (recentTmsEvents && recentTmsEvents.length > 0) && !isAdultTeamTennisClub && (
                        <>
                            <h6>Past Events</h6>
                            <TMSEventsList
                                eventsList={recentTmsEvents}
                                type={RECENT}
                                showAll={false}
                                auth={auth}
                                coreUI={coreUI}
                                isAdminOrOwner={isClubAdminOrOwner(clubDetails)}
                                canRunEvents={canRunEvents(clubDetails)}
                                isOwner={isClubOwner(clubDetails)}
                                isPersonalClub={isPersonalClub(clubDetails.tierType)}
                                isTournamentClub={isTournamentClub(clubDetails.tierType)}
                                isClubMember={isClubMember}
                                tmsEventsFetchState={tmsEventsFetchState}
                                clubIsFreeCollege={clubIsFreeCollege}
                                onUpgradeToCollegeClick={onUpgradeToCollegeClick}
                                onShowAllClick={(ev) => {
                                    onShowAllEventsClick(ev, RECENT);
                                }}
                                onCreateEventClick={onCreateEventClick}
                                isProfilePage={false}
                            />
                        </>
                    )}
                    {!isClubAdminOrOwner(clubDetails) && (tierType.isHighSchool || tierType.isCollege) &&
                        !((schoolDetails && schoolDetails.roster && schoolDetails.roster.length > 0) ||
                            (upcomingTeamEvents && upcomingTeamEvents.length > 0) ||
                            (recentTeamEvents && recentTeamEvents.length > 0)) && (
                            <div className="row mt64">
                                <div className="col-12">
                                    <p className="text-center">No profile info has been added yet<br />
                                        Check back for roster and match results
                                    </p>
                                </div>
                            </div>
                        )}
                </div>
                <div className="col-md-4">
                    <div className="d-none d-md-block">
                        <SidePanel
                            auth={auth}
                            clubType={clubType}
                            clubDetails={clubDetails}
                            handleUploadPhoto={handleUploadPhoto}
                            handleUploadLogoStart={handleUploadLogoStart}
                            removeSponsorLogo={removeSponsorLogo}
                            sendMessage={sendMessage}
                        />
                    </div>
                    <div className="d-block d-md-none">
                        <SidePanelBottomSection
                            clubDetails={clubDetails}
                        />
                    </div>
                </div>
            </div>
        );
    }
}
OverviewTabContent.propTypes = {
    clubDetails: PropTypes.objectOf(PropTypes.any).isRequired,
    auth: PropTypes.objectOf(PropTypes.any).isRequired,
    clubType: PropTypes.string,
    handleUploadPhoto: PropTypes.func,
    handleUploadLogoStart: PropTypes.func,
    removeSponsorLogo: PropTypes.func,
    checkGate: PropTypes.func.isRequired,
    featureGates: PropTypes.shape({
        COLLEGE_DUAL_MATCH: PropTypes.string,
    }).isRequired,
    tmsEventsFetchState: PropTypes.string,
    schoolDetailsState: PropTypes.instanceOf(Object).isRequired,
    schoolDetails: PropTypes.instanceOf(Object),
    handleTabClick: PropTypes.func,
    onUpgradeToCollegeClick: PropTypes.func,
    onShowAllEventsClick: PropTypes.func,
    onCreateEventClick: PropTypes.func,
    isAdminOrOwner: PropTypes.bool,
    sendMessage: PropTypes.func,
    power6Stats: PropTypes.string,
    power6StatsState: PropTypes.string,
    isClubMember: PropTypes.bool,
    highSchoolStandingsSeasons: PropTypes.arrayOf(PropTypes.shape),
    highSchoolStandings: PropTypes.arrayOf(PropTypes.shape),
    highSchoolStandingsState: PropTypes.instanceOf(Object).isRequired,
    adultTeamTennisRosterState: PropTypes.instanceOf(Object),
    adultTeamTennisRoster: PropTypes.arrayOf(PropTypes.shape),
    adultTeamTennisEvents: PropTypes.arrayOf(PropTypes.shape),
    adultTeamTennisStandings: PropTypes.arrayOf(PropTypes.shape),
    adultTeamTennisStandingsState: PropTypes.instanceOf(Object),
    getAdultTeamTennisStandings: PropTypes.func,
    coreUI: PropTypes.instanceOf(Object).isRequired,
};

OverviewTabContent.defaultProps = {
    schoolDetails: {},
    adultTeamTennisRosterState: {},
    adultTeamTennisStandingsState: {},
};

export default withStatsig(OverviewTabContent);
